
import request from '@/utils/ajax';



export function createChannel(data) {
  return request({
    url: '/pms/crm/createChannel',
    method: 'post',
    data,
  });
}

// 修改渠道
export function updateChannel(data) {
  return request({
    url: '/pms/crm/updateChannel',
    method: 'put',
    data,
  });
}

//全部渠道列表接口
export function queryValidChannels(data) {
  return request({
    url: '/pms/crm/allChannel',
    method: 'get',
    params: data
  });
}
